import { Config } from './config';

export default {
    title: 'nodeAdmin/components/config'
}

export const config = () => <Config title={'Title'} value={'value'} />
